import { ISelectOptions } from "../interfaces";
import * as moment from "moment";
import "moment-timezone";
export const INSPECTIONADDCUTOFF = '07-01-2024';
export const INSPECTIONNONOPCUTOFF = '07-31-2024';
export const monthsArray = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
export const SUBMISSION_FAILED =
  "Something went wrong please try again later...!";
export const LOCAL_STORAGE_KEY = "EnviroConnectUserInfo";
export const FORM_SUBMISSION_SUCCESS = "Form submitted successfully...!!!";
export const EMPTY_FIELD_MESSAGE = "Please fill all the fields first.";
export function years() {
  const options: ISelectOptions[] = [];
  //let month = new Date().toLocaleString("en-US", {timeZone: "America/Chicago", year: 'numeric'});
  // let year = moment(new Date()).tz("America/chicago").format("YYYY");
  for (let i = 2016; i <= new Date().getFullYear() + 1; i++) {
    options.push({
      label: i.toString(),
      value: i.toString(),
    });
  }
  return options;
}

export function quarters() {
  let q = ["First", "Second", "Third", "Fourth"];
  const options: ISelectOptions[] = [];
  for (let i = 1; i < 5; i++) {
    options.push({
      label: q[i - 1],
      value: i.toString(),
    });
  }
  return options;
}

export const monthsAndYears = [
  {
    label: "Jan",
    value: "01",
  },
  {
    label: "Feb",
    value: "02",
  },
  {
    label: "Mar",
    value: "03",
  },
  {
    label: "Apr",
    value: "04",
  },
  {
    label: "May",
    value: "05",
  },
  {
    label: "Jun",
    value: "06",
  },
  {
    label: "Jul",
    value: "07",
  },
  {
    label: "Aug",
    value: "08",
  },
  {
    label: "Sep",
    value: "09",
  },
  {
    label: "Oct",
    value: "10",
  },
  {
    label: "Nov",
    value: "11",
  },
  {
    label: "Dec",
    value: "12",
  },
];

export function quarterMonths() {
  let q = ["First", "Second", "Third", "Fourth"];
  const options: ISelectOptions[] = [
    {
      label: "First",
      value: "01",
    },
    {
      label: "Second",
      value: "02",
    },
    {
      label: "Third",
      value: "03",
    },
    {
      label: "Fourth",
      value: "04",
    },
  ];
  return options;
}
export const SIGNATURE_ERROR = "Please add your signature.";
export const SubmittedBy = "Submitted By";

export const questionData = [
  {
    Question_Num: 1,
    Question: "Has it rained in the past 24 hours?",
    Questiontype: "YesNoType",
    containsComment: true,
    CommentQuestion: "Comments",
    CommentQuestionNum: 2,
    CommentQuestionLabel: "Rain Amount in inches?",
    customLabelForComments: "2",
  },

  {
    Question_Num: 3,
    Question: "Is the plant operating today?",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 4,
    Question:
      "Housekeeping was performed (includes trash pick-up, trip hazards, _)",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 5,
    Question: "Oil spills and leaks are cleaned up (under 25 gallons).",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 6,
    Question: "Dust collectors were inspected for excess emissions.",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 7,
    Question: "Bags in the dust collectors were replaced.",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 8,
    Question:
      "Inspected cement and flyash fill pipes - account for all caps, locks & keys.",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 9,
    Question: "Plant property was swept today (by 3rd party sweeping company).",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 10,
    Question: "Plant property was swept today (with in-house sweeper truck).",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 11,
    Question: "Plant property was washed down (using hose, truck, loader,_).",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 12,
    Question: "Aggregate stockpiles were watered.",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 13,
    Question: "Burners on the boilers were checked.",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 14,
    /*tslint:disable-next-line*/
    Question:
      "Did you receive a visit from a government agency today (EPA, OSHA, TCEQ, ADEQ, City, County, etc ?.)?",
    Questiontype: "YesNoType",
    containsComment: true,
    CommentQuestion: "Comments",
    CommentQuestionNum: 15,
    customLabelForComments: "15",
    CommentQuestionLabel: "Comments",
  },
  {
    Question_Num: 16,
    Question:
      "Are there any conditions identified that need immediate correction?",
    Questiontype: "YesNoType",
    containsComment: true,
    CommentQuestion: "Comments",
    CommentQuestionNum: 17,
    CommentQuestionLabel: "Comments",
    customLabelForComments: "17",
  },
];

export const MonthlySWData = [
  {
    Question_Num: 60,
    Question: "Weather",
    Questiontype: "Comments",
    CommentQuestionNum: 60,
    customLabel: "A",
  },
  {
    Question: "Plant/Dust Collection/Containment System",
    Questiontype: "title",
  },
  {
    Question_Num: 1,
    Question: "Cement and flyash are contained in silos.",
    Questiontype: "YesNoType",
  },

  {
    Question_Num: 2,
    Question:
      "All bags in the dust collector(s) have been inspected and checked for buildup.",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 3,
    Question: "Dust collector(s) has been cleaned out.",
    Questiontype: "YesNoType",
    containsComment: true,
    CommentQuestion: "Date",
    CommentQuestionNum: 4,
    CommentQuestionLabel: "Date",
  },

  {
    Question_Num: 5,
    Question: "Dust collector bags have been replaced.",
    Questiontype: "YesNoType",
    containsComment: true,
    CommentQuestion: "Date",
    CommentQuestionNum: 6,
    CommentQuestionLabel: "Date",
  },
  {
    Question_Num: 7,
    Question:
      "Bag house and dust collector systems are clean and functioning properly.",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 8,
    Question:
      "Silo overfill equipment has been tested: bin indicators, visual and audible alarms all work.",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 9,
    Question: "Comments:",
    Questiontype: "Comments",
    CommentQuestionNum: 9,
  },
  {
    Question: "Shop/Vehicle Maintenance and Truck Parking Areas",
    Questiontype: "title",
  },
  {
    Question_Num: 10,
    Question: "Shop/vehicle maintenance areas are organized.",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 11,
    Question: "Truck parking areas are clean with minimal leaks and debris.",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 12,
    Question: "Comments:",
    Questiontype: "Comments",
    CommentQuestionNum: 12,
  },
  {
    Question: "Material Stockpiles and Comeback Concrete Areas",
    Questiontype: "title",
  },
  {
    Question_Num: 13,
    Question:
      "Sand and aggregate stockpiles are in order; recycle material piles are minimal.",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 14,
    Question: "There are no other windblown dry materials on site.",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 15,
    Question: "Comments:",
    Questiontype: "Comments",
    CommentQuestionNum: 15,
  },
  {
    Question: "Storage Tanks, Totes, and Containments",
    Questiontype: "title",
  },
  {
    Question_Num: 16,
    Question: "All tanks, totes, drums, and containers are properly labeled.",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 17,
    Question:
      "All petroleum tanks, totes, and drums (55 gallons and larger) have secondary containment.",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 18,
    Question:
      "Tanks, totes, and drums are in good condition; containers do not leak.",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 19,
    Question:
      "Piping is in good condition; there are no leaks, especially at connections.",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 20,
    Question:
      "Secondary containments are intact and will hold a spill (not cracked or damaged).",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 21,
    Question:
      "Secondary containments are free of trash or miscellaneous storage.",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 22,
    Question: "Secondary containment drain valves are closed & locked.",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 23,
    Question:
      "There is minimal accumulation of oil and/or admixtures inside their secondary containments.",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 24,
    Question: "Oil pumps do not leak; no spills/leaks observed.",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 25,
    Question: "Fuel dispenser does not leak; no spills/leaks observed.",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 26,
    Question:
      "The admixture tank area (plants with no containment) is free of spills or leaks.",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 27,
    Question:
      "Areas outside secondary containments are free of oil and/or admixture spills.",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 28,
    Question: "Comments:",
    Questiontype: "Comments",
    CommentQuestionNum: 28,
  },
  {
    Question: "WATER MANAGEMENT",
    Questiontype: "title",
  },
  {
    Question_Num: 29,
    Question:
      "There are no water leaks on site.  This includes valves and lines.",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 30,
    Question: "Pits, ponds, and basins contain minimal amounts of sediment. ",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 31,
    Question: "Sediment has been cleaned out of pits, basins, and ponds.",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 32,
    Question: "Water pumps are working properly.",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 33,
    Question:
      "Water in pits and ponds does not show any signs of contamination (oil sheen, etc).",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 34,
    Question: "Areas with sheet flow runoff have sediment filters.",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 35,
    Question: "Comments:",
    Questiontype: "Comments",
    CommentQuestionNum: 35,
  },
  {
    Question: "HOUSEKEEPING",
    Questiontype: "title",
  },
  {
    Question_Num: 36,
    Question: "Site is free of trash and debris. ",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 37,
    Question: "Appropriate number of trash cans available.",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 38,
    Question: "Dumpsters have lids and plugs.",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 39,
    Question: "Buckets and containers (under 55 gallons) are properly labeled.",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 40,
    Question:
      "Containers and buckets have plugs or covers and not exposed to rain events and runoff.",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 41,
    Question: "There are no empty drums, totes or tanks on site.",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 42,
    Question: "Lighting is adequate and operational.",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 43,
    Question:
      "Used, leaking or corroded batteries are not exposed to water runoff.",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 44,
    Question: "Vegetation (landscaping, grass, shrubs, etc) is maintained.",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 45,
    Question:
      "Hoses are appropriately placed/hung and pose no tripping hazard.",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 46,
    Question: "Good housekeeping is occurring on site.",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 47,
    Question: "Potential pollutants are not exposed to storm water runoff",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 48,
    Question: "Comments:",
    Questiontype: "Comments",
    CommentQuestionNum: 48,
  },
  {
    Question: "OUTFALLS",
    Questiontype: "title",
  },
  {
    Question_Num: 49,
    Question:
      "Structual controls at outfall(s) are in good condition and do not need to be repaired or replaced.",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 50,
    Question: "Drainage paths are not clogged or obstructed.",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 51,
    Question: "No erosion or contamination was observed at Outfall 1.",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 52,
    Question: "No erosion or contamination was observed at Outfall 2.",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 53,
    Question: "No erosion or contamination was observed at Outfall 3.",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 54,
    Question: "No erosion or contamination was observed at Outfall 4.",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 55,
    Question: "Comments:",
    Questiontype: "Comments",
    CommentQuestionNum: 55,
  },
  {
    Question: "TEMPORARY/SEASONAL EQUIPMENT",
    Questiontype: "title",
  },
  {
    Question_Num: 56,
    /*tslint:disable-next-line*/
    Question:
      "Boiler fuel tank is located inside a containment with no visible signs of fuel spilled outside the containment",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 57,
    Question:
      "There are no visible signs of fuel spilled outside the boiler fuel containment",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 58,
    Question: "Valves and lines on boiler/chiller do not leak.",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 59,
    Question: "Comments:",
    Questiontype: "Comments",
    CommentQuestionNum: 59,
  },

  {
    Question_Num: 61,
    Question: "Time",
  },
];

export const MonthlySPCCData_OLD = [
  {
    Question_Num: 28,
    Question: "Weather",
    Questiontype: "Comments",
    CommentQuestionNum: 28,
    customLabel: "A",
  },
  {
    Question: "Tanks",
    Questiontype: "title",
  },
  {
    Question_Num: 1,
    Question: "Water in the diesel fuel tank?",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 2,
    Question: "Water in the unleaded fuel tank?",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 3,
    Question: "Water in any oil tanks?",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 4,
    Question: "Standing water in the secondary containments?",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 5,
    Question:
      "Water in interstice* (*space between the layers of a double-walled tank)?",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 6,
    Question: "Water in the spill container (fill pipe-tanker connection)?",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 7,
    Question: "Fire hazards, debris or miscellaneous storage in containments?",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 8,
    Question: "Containment drain valves are closed and locked?",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 9,
    Question: "Visible signs of leakage or spills inside the containment?",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 10,
    Question:
      "Visible signs of leakage or spills around tanks (without containment)?",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 11,
    Question: "Visible signs of leakage or spills outside the containment?",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 12,
    Question:
      "Ladder and platform structure insecure or with signs of severe corrosion or damage?",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 13,
    Question: "Fuel level gauges and over-fill alarms are working properly?",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 14,
    Question:
      "Other conditions that should be addressed for continued safe operation that may affect the SPCC plan?",
    Questiontype: "YesNoType",
  },
  {
    Question: "Portable Containers(Drums)",
    Questiontype: "title",
  },
  {
    Question_Num: 15,
    Question: "Portable containers are stored in a designated area?",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 16,
    Question:
      "There are no debris, spills, or other fire hazards in containment or storage areas?",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 17,
    Question: "Water in secondary containments?",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 18,
    Question:
      "Containment drain valves are inoperable or not in a closed position?",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 19,
    Question:
      "Visible signs of leakage or spillage around the containers or storage area?",
    Questiontype: "YesNoType",
  },
  {
    Question: "Leak Testing",
    Questiontype: "title",
  },
  {
    Question_Num: 20,
    Question: "Noticeable container distortions, buckling, denting or bulging?",
    Questiontype: "YesNoType",
  },
  {
    Question: "Other",
    Questiontype: "title",
  },
  {
    Question_Num: 21,
    Question: "Fuel reports/Inventory control is conducted monthly?",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 22,
    Question:
      "Oil or fuel spill and stains at the parking, maintenance, plant, or other areas?",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 23,
    Question: "Warning signs are visible and legible?",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 24,
    Question: "Spill kit is available and in good order?",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 25,
    Question: "Leakage or damage to pipelines?",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 26,
    /*tslint:disable-next-line*/
    Question:
      "If any incidents of non-compliance were indentified during the inspection, discuss corrective actions needed:",
    Questiontype: "Comments",
    CommentQuestionNum: 26,
  },
  {
    Question_Num: 27,
    Question:
      "If applicable, explain corrective actions taken since the last inspection:",
    Questiontype: "Comments",
    CommentQuestionNum: 27,
  },

  {
    Question_Num: 29,
    Question: "Time",
  },
];

export const MonthlySPCCData = [
  {
    Question_Num: 28,
    Question: "Weather",
    Questiontype: "Comments",
    CommentQuestionNum: 28,
    customLabel: "A",
  },
  {
    Question: "Tanks",
    Questiontype: "title",
  },
  {
    Question_Num: 1,
    Question: "Do you see, or are you aware of, water in the diesel fuel tank?",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 2,
    Question:
      "Do you see, or are you aware of, water in the unleaded fuel tank?",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 3,
    Question: "Do you see, or are you aware of, water in any of the oil tanks?",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 4,
    Question: "Is there standing water in any of the secondary containments?",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 5,
    Question:
      "Are you aware of any water in the interstice (this is the space between the layers of a double-walled tank)?",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 6,
    Question:
      "Do you see water in the spill container (this is where the tanker connects to the fill pipe)?",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 7,
    Question:
      "Do you see any potential fire hazards, such as debris or miscellaneous storage, in the secondary containments?",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 8,
    Question: "Are secondary containment drain valves closed and locked?",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 9,
    Question:
      "Do you see any signs of leakage or spills inside the secondary containments?",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 10,
    Question:
      "Do you see any signs of leakage or spills around tanks WITHOUT secondary containments??",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 11,
    Question:
      "Do you see any signs of leakage or spills outside secondary containments?",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 12,
    Question:
      "Are the ladder and platform structures secure and show no signs of severe corrosion or damage?",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 13,
    Question: "Are fuel level gauges and over-fill alarms working properly?",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 14,
    Question:
      "Are there any other conditions that should be addressed for continued safe operation that may affect the SPCC Plan?",
    Questiontype: "YesNoType",
  },
  {
    Question: "Portable Containers(Drums)",
    Questiontype: "title",
  },
  {
    Question_Num: 15,
    Question:
      "Do all portable containers (55-gallon drums) have secondary containments?",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 16,
    Question:
      "Do you see any potential fire hazards, such as debris or miscellaneous storage, where portable containers (55-gallon drums) are stored?",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 17,
    Question:
      "Is there standing water in the portable container (55-gallon drums) secondary containments?",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 18,
    Question:
      "Are drain valves closed on portable container (55-gallon drums )secondary containments?",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 19,
    Question:
      "Do you see signs of leakage or spills around (outside of) the portable container (55-gallon drums) secondary containments?",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 20,
    Question:
      "Do you notice any portable containers (55-gallon drums) buckling, denting, or bulging?",
    Questiontype: "YesNoType",
  },
  {
    Question: "Leak Testing",
    Questiontype: "title",
  },
  {
    Question_Num: 21,
    Question: "Are fuel reports/inventory control conducted monthly?",
    Questiontype: "YesNoType",
  },
  {
    Question: "Other",
    Questiontype: "title",
  },
  {
    Question_Num: 22,
    Question:
      "Do you see any oil or fuel spills or staining around the plant (parking, maintenance, pits, etc…)?",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 23,
    Question:
      "Are all tanks and portable containers (55-gallon drums) labeled with identification and warning signs?",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 24,
    Question: "Is a spill kit available and stocked with supplies?",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 25,
    Question:
      "Do you see, or are you aware of, any leakage or damage to the tank system pipelines?",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 26,
    /*tslint:disable-next-line*/
    Question:
      "If any incidents of non-compliance were indentified during the inspection, discuss corrective actions needed:",
    Questiontype: "Comments",
    CommentQuestionNum: 26,
  },
  {
    Question_Num: 27,
    Question:
      "If applicable, explain corrective actions taken since the last inspection:",
    Questiontype: "Comments",
    CommentQuestionNum: 27,
  },

  {
    Question_Num: 29,
    Question: "Time",
  },
];

export const MonthlyUSTSpill = [
  {
    Question_Num: 3,
    Question: " Lid intact?",
    Questiontype: "YesNoType",
    customLabel: "1",
  },
  {
    Question_Num: 4,
    Question: "Free of Debris?",
    Questiontype: "YesNoType",
    customLabel: "2",
  },
  {
    Question_Num: 5,
    Question: "Free of Cracks?",
    Questiontype: "YesNoType",
    customLabel: "3",
  },
  {
    Question_Num: 6,
    Question: "Actions Taken:",
    Questiontype: "Comments",
    CommentQuestionNum: 6,
    customLabel: "4",
  },
];

export const MonthlySpillLogs = [
  // {
  //     "Question_Num": 1,
  //     "Question": "Date"
  // },
  // {
  //     "Question_Num": 2,
  //     "Question": "Submitted By"
  // },
  {
    Question_Num: 3,
    Question: "Description of spill and/or leak:",
    Questiontype: "Comments",
    CommentQuestionNum: 3,
    customLabel: "",
  },
  {
    Question_Num: 4,
    Question: "Please explain the corrective actions taken.",
    Questiontype: "Comments",
    CommentQuestionNum: 4,
    customLabel: "",
  },
  {
    Question_Num: 3,
    Question: "Time",
  },
];

export const ShopInspection = [
  {
    Question_Num: 27,
    Question: "Weather",
    Questiontype: "Comments",
    CommentQuestionNum: 27,
    customLabel: "A",
  },
  {
    Question_Num: 1,
    Question: "Good housekeeping procedures are being practiced.",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 2,
    Question:
      "Shop materials, when not in use, are covered and not exposed to water runoff.",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 3,
    Question:
      "Used batteries are stored either inside the shop or covered and not exposed to water runoff.",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 4,
    Question: "Shop and vehicle maintenance areas are organized and clean.",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 5,
    Question:
      "Small spills and leaks in and around the shop are cleaned up as soon as possible.",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 6,
    Question:
      "Raw materials (located outside) are stored so their contact with storm water is minimal.",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 7,
    Question:
      "Corroded and/or leaking drums & buckets are stored in a contained covered area.",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 8,
    Question:
      "Drums & buckets without plugs or covers are stored in a covered area.",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 9,
    Question: "All tanks, drums, and buckets are labeled.",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 10,
    Question: "Fresh spills around the fuel island have been cleaned.",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 11,
    Question:
      "Oil leaks have been cleaned up at the mixer and haul truck parking areas.",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 12,
    Question:
      "Plenty of spill clean-up materials (spill kit) area available and organized.",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 13,
    Question:
      "Minimal amounts of used or waste materials are stored on site and in a covered area.",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 14,
    Question:
      "Pressure washer building and cleaning totes (valves) are in working order.",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 15,
    Question:
      /*tslint:disable-next-line*/
      "Finished product storage areas,recycling areas,loading and unloading areas,equipment storage areas, vehicle fueling and maintenance areas have been inspected and are in compliance with the permit.",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 16,
    Question: "Paved areas have been swept and cleaned.",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 17,
    Question: "Trash around site has been picked up.",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 18,
    Question:
      "Vegetation around drainage ditches and perimeter of property appears healthy.",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 19,
    Question: "Structural controls (earthen berms) are in good condition.",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 20,
    Question: "Conditions are satisfactory at Outfalls 001 and 002.",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 21,
    Question: "SWP3 training is current.",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 22,
    Question: '"Log of Spills and Leaks" is up to date.',
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 23,
    Question: "Overall compliance with TXR050000 TPDES permit requirements.",
    Questiontype: "YesNoType",
  },
  {
    Question_Num: 24,
    /*tslint:disable-next-line*/
    Question:
      "If any incidents of non-compliance were indentified during the inspection, discuss corrective actions needed:",
    Questiontype: "Comments",
    CommentQuestionNum: 24,
  },
  {
    Question_Num: 25,
    Question:
      "If applicable, explain corrective actions taken since the last inspection:",
    Questiontype: "Comments",
    CommentQuestionNum: 25,
  },
  {
    Question_Num: 26,
    Question: "CHANGES REQUIRED TO THE SWP3:",
    Questiontype: "Comments",
    CommentQuestionNum: 26,
  },
  {
    Question_Num: 28,
    Question: "Time",
  },
];

export const AllMonthlyPPM = [
  {
    Question_Num: 1,
    Question: "Charging hopper-wear-skirt-rubber",
  },
  {
    Question_Num: 2,
    Question: "Bearing",
  },
  {
    Question_Num: 3,
    Question: "Shaft",
  },
  {
    Question_Num: 4,
    Question: "Cage",
  },
  {
    Question_Num: 5,
    Question: "Tracking & Idlers",
  },
  {
    Question_Num: 6,
    Question: "Lacing",
  },
  {
    Question_Num: 7,
    Question: "Tears/holes/replace",
  },
  {
    Question_Num: 8,
    Question: "V-belts",
  },
  {
    Question_Num: 9,
    Question: "Transmission",
  },
  {
    Question_Num: 10,
    Question: "Lagging",
  },
  {
    Question_Num: 11,
    Question: "Belt scrapper",
  },

  {
    Question_Num: 12,
    Question: "Limit switches",
  },
  {
    Question_Num: 13,
    Question: "Wear",
  },
  {
    Question_Num: 14,
    Question: "Chain drive",
  },

  // OverHead Bins Title
  {
    Question_Num: 15,
    Question: "Wear",
  },
  {
    Question_Num: 16,
    Question: "Gates & Cylinders",
  },
  {
    Question_Num: 17,
    Question: "Agg Scales-Wear & Gates",
  },

  // Charging Conveyor Title

  {
    Question_Num: 18,
    Question: "Bearing",
  },
  {
    Question_Num: 19,
    Question: "Shaft",
  },

  {
    Question_Num: 20,

    Question: "Skirt Rubber",
  },
  {
    Question_Num: 21,

    Question: "Belts, Lacing & Idlers",
  },
  {
    Question_Num: 22,
    Question: "Lagging",
  },
  {
    Question_Num: 23,
    Question: "V-belts",
  },
  {
    Question_Num: 24,
    Question: "Transmission",
  },

  // Discharge Hopper/wear Title

  {
    Question_Num: 25,
    Question: "Wear",
  },
  {
    Question_Num: 26,
    Question: "Gum Chute",
  },

  // Dustshroud Title

  {
    Question_Num: 27,
    Question: "Piping & Ductwork & Canopy",
  },

  {
    Question_Num: 28,

    Question: "Wear/Leaks",
  },
  {
    Question_Num: 29,

    Question: "Bags/Socks",
  },
  {
    Question_Num: 30,

    Question: "Gate & Vibrator",
  },
  {
    Question_Num: 31,

    Question: "Scale Levers - Clean top of scale",
  },
  {
    Question_Num: 32,

    Question: "Air Pads",
  },

  // Silos Title

  {
    Question_Num: 33,
    Question: "Leaks/Clear ",
  },
  {
    Question_Num: 34,
    Question: "Bindicators",
  },
  {
    Question_Num: 35,
    Question: "Piping Fill Lines & Dust",
  },
  {
    Question_Num: 36,
    Question: "Aeration Pads",
  },
  {
    Question_Num: 37,
    Question: "Pressure",
  },

  // CEM UNLOADING EQUIP Title

  {
    Question_Num: 38,
    Question: "Belts & filters",
  },

  {
    Question_Num: 39,
    Question: "Cement screw-bearing, hangers",
  },
  {
    Question_Num: 40,
    Question: "Buckets & drive chain & shaft",
  },

  // Dust System Title

  {
    Question_Num: 41,
    Question: "Bags",
  },
  {
    Question_Num: 42,
    Question: "Duct Work",
  },
  {
    Question_Num: 43,
    Question: "Fan Blades",
  },
  {
    Question_Num: 44,
    Question: "Leaks",
  },

  // Admixture System Title

  {
    Question_Num: 45,
    Question: "Leaks Material/Air",
  },
  {
    Question_Num: 46,
    Question: "Winterized",
  },

  // Air Compressors Title

  {
    Question_Num: 47,
    Question: "Service Dates",
  },
  {
    Question_Num: 48,
    Question: "Leaks/Oil",
  },

  // Electrical Title

  {
    Question_Num: 49,
    Question: "Lose Wires or Conduit",
  },

  // Boilers Title

  {
    Question_Num: 50,
    Question: "Pressure",
  },
  {
    Question_Num: 51,
    Question: "Annual Inspection",
  },

  // Plant Maintenance Title
  {
    Question_Num: 52,
    Question: "Maintenance Reports",
  },
  {
    Question_Num: 53,
    Question: "General Condition",
  },
  {
    Question_Num: 54,
    Question: "Notes",
  },
];

export const AllMonthlyPPM1 = [
  // Stacking Conveyor Title

  {
    Question: "STACKING CONVEYOR",
    Questiontype: "title",
  },
  {
    Question_Num: 1,
    customLabel: "1",
    Question: "Charging hopper-wear-skirt-rubber",
    Questiontype: "YesNoTypeComment",
    containsComment: true,
    CommentQuestion: "Comments",
    CommentQuestionNum: 1,
    CommentQuestionLabel: "Comment",
  },
  {
    Question_Num: 2,
    customLabel: "2",
    Question: "Tail Pulley",
    Questiontype: "headingForSubsections",
  },
  {
    Question_Num: 2,
    Question: "Bearing",
    customLabel: "a",
    Questiontype: "subQuestions",
    containsComment: true,
    CommentQuestion: "Comments",
    CommentQuestionNum: 2,
    CommentQuestionLabel: "Comment",
  },
  {
    Question_Num: 3,
    Question: "Shaft",
    customLabel: "b",
    Questiontype: "subQuestions",
    containsComment: true,
    CommentQuestion: "Comments",
    CommentQuestionNum: 3,
    CommentQuestionLabel: "Comment",
  },
  {
    Question_Num: 4,
    Question: "Cage",
    customLabel: "c",
    Questiontype: "subQuestions",
    containsComment: true,
    CommentQuestion: "Comments",
    CommentQuestionNum: 4,
    CommentQuestionLabel: "Comment",
  },

  {
    Question_Num: 5,
    customLabel: "3",
    Question: "Belting",
    Questiontype: "headingForSubsections",
  },

  {
    Question_Num: 5,
    Question: "Tracking & Idlers",
    customLabel: "a",
    Questiontype: "subQuestions",
    containsComment: true,
    CommentQuestion: "Comments",
    CommentQuestionNum: 5,
    CommentQuestionLabel: "Comment",
  },
  {
    Question_Num: 6,
    Question: "Lacing",
    customLabel: "b",
    Questiontype: "subQuestions",
    containsComment: true,
    CommentQuestion: "Comments",
    CommentQuestionNum: 6,
    CommentQuestionLabel: "Comment",
  },
  {
    Question_Num: 7,
    Question: "Tears/holes/replace",
    customLabel: "c",
    Questiontype: "subQuestions",
    containsComment: true,
    CommentQuestion: "Comments",
    CommentQuestionNum: 7,
    CommentQuestionLabel: "Comment",
  },

  {
    Question_Num: 8,
    customLabel: "4",
    Question: "Head Pulley",
    Questiontype: "headingForSubsections",
  },
  {
    Question_Num: 8,
    Question: "V-belts",
    customLabel: "a",
    Questiontype: "subQuestions",
    containsComment: true,
    CommentQuestion: "Comments",
    CommentQuestionNum: 8,
    CommentQuestionLabel: "Comment",
  },
  {
    Question_Num: 9,
    Question: "Transmission",
    customLabel: "b",
    Questiontype: "subQuestions",
    containsComment: true,
    CommentQuestion: "Comments",
    CommentQuestionNum: 9,
    CommentQuestionLabel: "Comment",
  },
  {
    Question_Num: 10,
    Question: "Lagging",
    customLabel: "c",
    Questiontype: "subQuestions",
    containsComment: true,
    CommentQuestion: "Comments",
    CommentQuestionNum: 10,
    CommentQuestionLabel: "Comment",
  },
  {
    Question_Num: 11,
    Question: "Belt scrapper",
    customLabel: "d",
    Questiontype: "subQuestions",
    containsComment: true,
    CommentQuestion: "Comments",
    CommentQuestionNum: 11,
    CommentQuestionLabel: "Comment",
  },

  {
    Question_Num: 12,
    customLabel: "5",
    Question: "Turn Head",
    Questiontype: "headingForSubsections",
  },
  {
    Question_Num: 12,
    Question: "Limit switches",
    customLabel: "a",
    Questiontype: "subQuestions",
    containsComment: true,
    CommentQuestion: "Comments",
    CommentQuestionNum: 12,
    CommentQuestionLabel: "Comment",
  },
  {
    Question_Num: 13,
    Question: "Wear",
    customLabel: "b",
    Questiontype: "subQuestions",
    containsComment: true,
    CommentQuestion: "Comments",
    CommentQuestionNum: 13,
    CommentQuestionLabel: "Comment",
  },
  {
    Question_Num: 14,
    Question: "Chain drive",
    customLabel: "c",
    Questiontype: "subQuestions",
    containsComment: true,
    CommentQuestion: "Comments",
    CommentQuestionNum: 14,
    CommentQuestionLabel: "Comment",
  },

  // OverHead Bins Title

  {
    Question: "OVERHEAD BINS",
    Questiontype: "title",
  },
  {
    Question_Num: 15,
    customLabel: "6",
    Question: "Wear",
    Questiontype: "YesNoTypeComment",
    containsComment: true,
    CommentQuestion: "Comments",
    CommentQuestionNum: 15,
    CommentQuestionLabel: "Comment",
  },
  {
    Question_Num: 16,
    customLabel: "7",
    Question: "Gates & Cylinders",
    Questiontype: "YesNoTypeComment",
    containsComment: true,
    CommentQuestion: "Comments",
    CommentQuestionNum: 16,
    CommentQuestionLabel: "Comment",
  },
  {
    Question_Num: 17,
    customLabel: "8",
    Question: "Agg Scales-Wear & Gates",
    Questiontype: "YesNoTypeComment",
    containsComment: true,
    CommentQuestion: "Comments",
    CommentQuestionNum: 17,
    CommentQuestionLabel: "Comment",
  },

  // Charging Conveyor Title

  {
    Question: "CHARGING CONVEYOR",
    Questiontype: "title",
  },
  {
    Question_Num: 18,
    customLabel: "9",
    Question: "Tail Pulley",
    Questiontype: "headingForSubsections",
  },
  {
    Question_Num: 18,
    Question: "Bearing",
    customLabel: "a",
    Questiontype: "subQuestions",
    containsComment: true,
    CommentQuestion: "Comments",
    CommentQuestionNum: 18,
    CommentQuestionLabel: "Comment",
  },
  {
    Question_Num: 19,
    Question: "Shaft",
    customLabel: "b",
    Questiontype: "subQuestions",
    containsComment: true,
    CommentQuestion: "Comments",
    CommentQuestionNum: 19,
    CommentQuestionLabel: "Comment",
  },

  {
    Question_Num: 20,
    customLabel: "10",
    Question: "Skirt Rubber",
    Questiontype: "YesNoTypeComment",
    containsComment: true,
    CommentQuestion: "Comments",
    CommentQuestionNum: 20,
    CommentQuestionLabel: "Comment",
  },
  {
    Question_Num: 21,
    customLabel: "11",
    Question: "Belts, Lacing & Idlers",
    Questiontype: "YesNoTypeComment",
    containsComment: true,
    CommentQuestion: "Comments",
    CommentQuestionNum: 21,
    CommentQuestionLabel: "Comment",
  },
  {
    Question_Num: 22,
    customLabel: "12",
    Question: "Head Pulley",
    Questiontype: "headingForSubsections",
  },
  {
    Question_Num: 22,
    Question: "Lagging",
    customLabel: "a",
    Questiontype: "subQuestions",
    containsComment: true,
    CommentQuestion: "Comments",
    CommentQuestionNum: 22,
    CommentQuestionLabel: "Comment",
  },
  {
    Question_Num: 23,
    Question: "V-belts",
    customLabel: "b",
    Questiontype: "subQuestions",
    containsComment: true,
    CommentQuestion: "Comments",
    CommentQuestionNum: 23,
    CommentQuestionLabel: "Comment",
  },
  {
    Question_Num: 24,
    Question: "Transmission",
    customLabel: "c",
    Questiontype: "subQuestions",
    containsComment: true,
    CommentQuestion: "Comments",
    CommentQuestionNum: 24,
    CommentQuestionLabel: "Comment",
  },

  // Discharge Hopper/wear Title

  {
    Question: "DISCHARGE HOPPER/WEAR",
    Questiontype: "title",
  },
  {
    Question_Num: 25,
    customLabel: "13",
    Question: "Wear",
    Questiontype: "YesNoTypeComment",
    containsComment: true,
    CommentQuestion: "Comments",
    CommentQuestionNum: 25,
    CommentQuestionLabel: "Comment",
  },
  {
    Question_Num: 26,
    customLabel: "14",
    Question: "Gum Chute",
    Questiontype: "YesNoTypeComment",
    containsComment: true,
    CommentQuestion: "Comments",
    CommentQuestionNum: 26,
    CommentQuestionLabel: "Comment",
  },

  // Dustshroud Title

  {
    Question: "DUSTSHROUD",
    Questiontype: "title",
  },

  {
    Question_Num: 27,
    customLabel: "15",
    Question: "Piping & Ductwork & Canopy",
    Questiontype: "YesNoTypeComment",
    containsComment: true,
    CommentQuestion: "Comments",
    CommentQuestionNum: 27,
    CommentQuestionLabel: "Comment",
  },
  {
    Question: "CEMENT SCALE",
    Questiontype: "title",
  },
  {
    Question_Num: 28,
    customLabel: "16",
    Question: "Wear/Leaks",
    Questiontype: "YesNoTypeComment",
    containsComment: true,
    CommentQuestion: "Comments",
    CommentQuestionNum: 28,
    CommentQuestionLabel: "Comment",
  },
  {
    Question_Num: 29,
    customLabel: "17",
    Question: "Bags/Socks",
    Questiontype: "YesNoTypeComment",
    containsComment: true,
    CommentQuestion: "Comments",
    CommentQuestionNum: 29,
    CommentQuestionLabel: "Comment",
  },
  {
    Question_Num: 30,
    customLabel: "18",
    Question: "Gate & Vibrator",
    Questiontype: "YesNoTypeComment",
    containsComment: true,
    CommentQuestion: "Comments",
    CommentQuestionNum: 30,
    CommentQuestionLabel: "Comment",
  },
  {
    Question_Num: 31,
    customLabel: "19",
    Question: "Scale Levers - Clean top of scale",
    Questiontype: "YesNoTypeComment",
    containsComment: true,
    CommentQuestion: "Comments",
    CommentQuestionNum: 31,
    CommentQuestionLabel: "Comment",
  },
  {
    Question_Num: 32,
    customLabel: "20",
    Question: "Air Pads",
    Questiontype: "YesNoTypeComment",
    containsComment: true,
    CommentQuestion: "Comments",
    CommentQuestionNum: 32,
    CommentQuestionLabel: "Comment",
  },

  // Silos Title

  {
    Question: "SILOS",
    Questiontype: "title",
  },
  {
    Question_Num: 33,
    customLabel: "21",
    Question: "Leaks/Clear ",
    Questiontype: "YesNoTypeComment",
    containsComment: true,
    CommentQuestion: "Comments",
    CommentQuestionNum: 33,
    CommentQuestionLabel: "Comment",
  },
  {
    Question_Num: 34,
    customLabel: "22",
    Question: "Bindicators",
    Questiontype: "YesNoTypeComment",
    containsComment: true,
    CommentQuestion: "Comments",
    CommentQuestionNum: 34,
    CommentQuestionLabel: "Comment",
  },
  {
    Question_Num: 35,
    customLabel: "23",
    Question: "Piping Fill Lines & Dust",
    Questiontype: "YesNoTypeComment",
    containsComment: true,
    CommentQuestion: "Comments",
    CommentQuestionNum: 35,
    CommentQuestionLabel: "Comment",
  },
  {
    Question_Num: 36,
    customLabel: "24",
    Question: "Aeration Pads",
    Questiontype: "YesNoTypeComment",
    containsComment: true,
    CommentQuestion: "Comments",
    CommentQuestionNum: 36,
    CommentQuestionLabel: "Comment",
  },
  {
    Question_Num: 37,
    customLabel: "25",
    Question: "Pressure",
    Questiontype: "YesNoTypeComment",
    containsComment: true,
    CommentQuestion: "Comments",
    CommentQuestionNum: 37,
    CommentQuestionLabel: "Comment",
  },

  // CEM UNLOADING EQUIP Title

  {
    Question: "CEM UNLOADING EQUIP",
    Questiontype: "title",
  },

  {
    Question_Num: 38,
    customLabel: "26",
    Question: "Pneumatic - Fuller",
    Questiontype: "headingForSubsections",
  },
  {
    Question_Num: 38,
    Question: "Belts & filters",
    customLabel: "a",
    Questiontype: "subQuestions",
    containsComment: true,
    CommentQuestion: "Comments",
    CommentQuestionNum: 38,
    CommentQuestionLabel: "Comment",
  },

  {
    Question_Num: 39,
    customLabel: "27",
    Question: "Bucket Elevators",
    Questiontype: "headingForSubsections",
  },
  {
    Question_Num: 39,
    Question: "Cement screw-bearing, hangers",
    customLabel: "a",
    Questiontype: "subQuestions",
    containsComment: true,
    CommentQuestion: "Comments",
    CommentQuestionNum: 39,
    CommentQuestionLabel: "Comment",
  },
  {
    Question_Num: 40,
    Question: "Buckets & drive chain & shaft",
    customLabel: "b",
    Questiontype: "subQuestions",
    containsComment: true,
    CommentQuestion: "Comments",
    CommentQuestionNum: 40,
    CommentQuestionLabel: "Comment",
  },

  // Dust System Title

  {
    Question: "DUST SYSTEM",
    Questiontype: "title",
  },
  {
    Question_Num: 41,
    customLabel: "28",
    Question: "Bags",
    Questiontype: "YesNoTypeComment",
    containsComment: true,
    CommentQuestion: "Comments",
    CommentQuestionNum: 41,
    CommentQuestionLabel: "Comment",
  },
  {
    Question_Num: 42,
    customLabel: "29",
    Question: "Duct Work",
    Questiontype: "YesNoTypeComment",
    containsComment: true,
    CommentQuestion: "Comments",
    CommentQuestionNum: 42,
    CommentQuestionLabel: "Comment",
  },
  {
    Question_Num: 43,
    customLabel: "30",
    Question: "Fan Blades",
    Questiontype: "YesNoTypeComment",
    containsComment: true,
    CommentQuestion: "Comments",
    CommentQuestionNum: 43,
    CommentQuestionLabel: "Comment",
  },
  {
    Question_Num: 44,
    customLabel: "31",
    Question: "Leaks",
    Questiontype: "YesNoTypeComment",
    containsComment: true,
    CommentQuestion: "Comments",
    CommentQuestionNum: 44,
    CommentQuestionLabel: "Comment",
  },

  // Admixture System Title

  {
    Question: "ADMIXTURE SYSTEM",
    Questiontype: "title",
  },
  {
    Question_Num: 45,
    customLabel: "32",
    Question: "Leaks Material/Air",
    Questiontype: "YesNoTypeComment",
    containsComment: true,
    CommentQuestion: "Comments",
    CommentQuestionNum: 45,
    CommentQuestionLabel: "Comment",
  },
  {
    Question_Num: 46,
    customLabel: "33",
    Question: "Winterized",
    Questiontype: "YesNoTypeComment",
    containsComment: true,
    CommentQuestion: "Comments",
    CommentQuestionNum: 46,
    CommentQuestionLabel: "Comment",
  },

  // Air Compressors Title

  {
    Question: "AIR COMPRESSORS",
    Questiontype: "title",
  },
  {
    Question_Num: 47,
    customLabel: "34",
    Question: "Service Dates",
    Questiontype: "YesNoTypeComment",
    containsComment: true,
    CommentQuestion: "Comments",
    CommentQuestionNum: 47,
    CommentQuestionLabel: "Comment",
  },
  {
    Question_Num: 48,
    customLabel: "35",
    Question: "Leaks/Oil",
    Questiontype: "YesNoTypeComment",
    containsComment: true,
    CommentQuestion: "Comments",
    CommentQuestionNum: 48,
    CommentQuestionLabel: "Comment",
  },

  // Electrical Title

  {
    Question: "ELECTRICAL",
    Questiontype: "title",
  },
  {
    Question_Num: 49,
    customLabel: "36",
    Question: "Lose Wires or Conduit",
    Questiontype: "YesNoTypeComment",
    containsComment: true,
    CommentQuestion: "Comments",
    CommentQuestionNum: 49,
    CommentQuestionLabel: "Comment",
  },

  // Boilers Title

  {
    Question: "BOILERS",
    Questiontype: "title",
  },
  {
    Question_Num: 50,
    customLabel: "37",
    Question: "Pressure",
    Questiontype: "YesNoTypeComment",
    containsComment: true,
    CommentQuestion: "Comments",
    CommentQuestionNum: 50,
    CommentQuestionLabel: "Comment",
  },
  {
    Question_Num: 51,
    customLabel: "38",
    Question: "Annual Inspection",
    Questiontype: "YesNoTypeComment",
    containsComment: true,
    CommentQuestion: "Comments",
    CommentQuestionNum: 51,
    CommentQuestionLabel: "Comment",
  },

  // Plant Maintenance Title

  {
    Question: "PLANT MAINTENANCE",
    Questiontype: "title",
  },
  {
    Question_Num: 52,
    customLabel: "39",
    Question: "Maintenance Reports",
    Questiontype: "YesNoTypeComment",
    containsComment: true,
    CommentQuestion: "Comments",
    CommentQuestionNum: 52,
    CommentQuestionLabel: "Comment",
  },
  {
    Question_Num: 53,
    customLabel: "40",
    Question: "General Condition",
    Questiontype: "YesNoTypeComment",
    containsComment: true,
    CommentQuestion: "Comments",
    CommentQuestionNum: 53,
    CommentQuestionLabel: "Comment",
  },
  {
    Question_Num: 54,
    Question: "Notes",
  },
];

export const INSPECTIONTYPES = {
  DailyForm: "Daily Form",
  "Daily Plant Preventive": "Daily Plant Preventive",
  PlantPreventive: "Plant Preventive",
  DailyPlantPreventive: "Daily Plant Preventive",
  MonthlySPCC: "Monthly SPCC",
  MonthlySpillLogs: "Monthly Spill Logs",
  MonthlySW: "Monthly SW",
  MonthlyUSTRect: "Monthly UST Rect",
  MonthlyUSTSpill: "UST Spill Container",
  QTRVisual: "QTR Visual",
  QuarterVisual: "QTR Visual",
  ShopInspection: "Shop Inspection",
};
export function inspectionType(type) {
  return INSPECTIONTYPES[type] || type;
}
export function parentInspectionType(type) {
  return Object.keys(INSPECTIONTYPES).find(
    (key) => INSPECTIONTYPES[key] === type
  );
}
export function convertAnswer(ans) {
  let answer = ans;
  switch (ans) {
    case "N/A":
      answer = "Not Applicable";
      break;
    default:
      answer = ans;
  }
  return answer;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/constants/generals.ts